module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-04.cce4a656.jpg";